import { createRouter, createWebHistory } from "vue-router";

// Landing
import Home from "@/landing/pages/Home.vue";
import Profile from "@/landing/pages/Profile.vue";

// Maintenance
import Maintenance from "@/Maintenance.vue";

const landingRoutes = [
	{
		path: "/",
		name: "Home",
		component: Home,
		meta: { title: "Cat Sitter Indonesia - Jasa Penitipan & Perawatan Kucing" },
	},
	{
		path: "/profile",
		name: "Profile",
		component: Profile,
		meta: { title: "Cat Sitter Profile | Cat Sitter Indonesia" },
	},
	{
		path: "/:catchAll(.*)",
		redirect: "/",
	},
];

const maintenanceRoutes = [
	{
		path: "/",
		name: "Maintenance",
		meta: { title: "Maintenance | Cat Sitter Indonesia" },
		component: Maintenance,
	},
	{
		path: "/:catchAll(.*)",
		redirect: "/",
	},
];

const router = createRouter({
	history: createWebHistory("/"),
	routes: landingRoutes,
});

export default router;
